import React from 'react';
import { useTranslation } from 'react-i18next';

import { IconInfo } from '../Icon';
import { Action, Label, Wrapper } from './wrapper';

export interface IAlert {
  children: React.ReactNode;
  onInfo?: () => void;
}

const Badge = ({ children, onInfo }: IAlert) => {
  const { t } = useTranslation(['other']);

  return (
    <Wrapper>
      <Label>{children}</Label>
      {onInfo && (
        <Action onClick={onInfo} title={t('moreInformation', { ns: 'common' })}>
          <IconInfo />
        </Action>
      )}
    </Wrapper>
  );
};

export default Badge;
